import { applyDecorators } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { ApiPropertyOptions } from '@nestjs/swagger/dist/decorators/api-property.decorator';
import { isDefined, IsOptional, IsString, Matches, MaxLength, MinLength } from 'class-validator';
import { NOT_MATCHES_TO_PATTERN, TOO_LONG_STRING, TOO_SHORT_STRING } from '../constants';
import { BaseDecoratorOptions } from '../types';
import { Transform } from 'class-transformer';

type PropertyStringParams = {
  pattern?: RegExp;
  trim?: boolean;
} & BaseDecoratorOptions<string> &
  Pick<ApiPropertyOptions, 'minLength' | 'maxLength'>;

export function ApiPropertyString({
  isOptional,
  pattern,
  trim,
  ...options
}: PropertyStringParams = {}): PropertyDecorator {
  const propertyOptions: ApiPropertyOptions = {
    type: String,
    example: 'string',
    ...(pattern && { pattern: pattern.toString() }),
    ...options,
  };

  const { minLength, maxLength } = options;
  return applyDecorators(
    ...(isOptional ? [IsOptional(), ApiPropertyOptional(propertyOptions)] : [ApiProperty(propertyOptions)]),
    IsString(),
    ...(trim ? [Transform(({ value }) => value && value.trim())] : []),
    ...(!isNaN(minLength!) ? [MinLength(minLength!, { message: TOO_SHORT_STRING, context: { minLength } })] : []),
    ...(!isNaN(maxLength!) ? [MaxLength(maxLength!, { message: TOO_LONG_STRING, context: { maxLength } })] : []),
    ...(pattern
      ? [Matches(pattern!, { message: NOT_MATCHES_TO_PATTERN, context: { pattern: pattern.toString() } })]
      : []),
  );
}
